module.exports = __webpack_public_path__ + "img/action-addEdit.bc71d465.svg";